import { Container, Grid, styled } from '@mui/material'
import InfoLabel from '../../components/Labels/InfoLabel'

export const Root = styled('div')`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  background: ${props => props.theme.palette.brand.gray3};
`

export const Wrapper = styled(Container)`
  margin: ${props => props.margin};
`

export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};
`

export const EntityColorLabel = styled(InfoLabel)`
  margin-right: 16px;
`
